import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginPageComponent } from './pages/login-page/login-page.component';
import { MainPageComponent } from './pages/main-page/main-page.component';
import { UserDetailComponent } from './components/users/user-detail/user-detail.component';
import { ManageUserPageComponent } from './pages/manage/users/manage-user-page/manage-user-page.component';
import { MasterDataPageComponent } from './pages/manage/master-data/master-data-page/master-data-page.component';
import { authGuard } from './guards/auth.guard';
import { OpenConnectionsPageComponent } from './pages/manage/open-connections/open-connections-page/open-connections-page.component';

const routes: Routes = [
  {
    path: 'login',
    component: LoginPageComponent,
  },
  {
    path: 'dashboard',
    component: MainPageComponent,
    canActivate: [authGuard],
  },
  {
    path: 'main',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: 'master-data',
    component: MasterDataPageComponent,
    canActivate: [authGuard],
  },
  {
    path: 'users',
    component: ManageUserPageComponent,
    canActivate: [authGuard],
  },
  {
    path: 'open-connections',
    component: OpenConnectionsPageComponent,
    canActivate: [authGuard],
  },
  {
    path: 'main/users/detail',
    component: UserDetailComponent,
    canActivate: [authGuard],
  },
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
